<template>
<div style="height:100%;color: white">
<!--  <button @click="test1">处理</button><button @click="test2">完成</button>-->
  <div v-if="isWeiNing">
    <div style="height: 50px;padding-top: 5px">
      <div class="kefu-item" v-for="item in CustomerOnlineType" :key="item.id">
        <div class="kefu-red" v-if="item.isStatus === 2"><strong>{{item.customersipnum}}</strong></div>
        <div class="kefu-green" v-if="item.isStatus === 1"><strong>{{item.customersipnum}}</strong></div>
        <div class="kefu-gray" v-if="item.isStatus === 0"><strong>{{item.customersipnum}}</strong></div>
      </div>
    </div>
    <el-row style="margin: 0 0 0 15px">
      <el-col :span="8">
        <div class="item-box">
          <div class="icon-left"><img src="../../../assets/SHscreen/monitor_lvshi.png"></div>
          <div class="info-right">
            <div><span>律师</span><br><span style="font-size: 12px;color: #cccccc">在线 / 总数</span></div>
            <div><span style="font-size: 20px;color: #24ff9b">{{ laweronlinecount }}</span> / <span style="font-size: 20px;color: #24bfff">{{lawercount}}</span></div>
          </div>
        </div>
      </el-col>
      <el-col :span="8">
        <div class="item-box">
          <div class="icon-left"><img src="../../../assets/SHscreen/monitor_waiqin.png"></div>
          <div class="info-right">
            <div><span>外勤</span><br><span style="font-size: 12px;color: #cccccc">总数</span></div>
            <div><span style="font-size: 20px;color: #24bfff">{{outsidecount}}</span></div>
          </div>
        </div>
      </el-col>
      <el-col :span="8">
        <div class="item-box">
          <div class="icon-left"><img src="../../../assets/SHscreen/monitor_fuwushang.png"></div>
          <div class="info-right">
            <div><span>服务商</span><br><span style="font-size: 12px;color: #cccccc">在线 / 总数</span></div>
            <div><span style="font-size: 20px;color: #24ff9b">{{ suppliercount }}</span> / <span style="font-size: 20px;color: #24bfff">{{supplieronlinecount}}</span></div>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
  <el-row v-else style="margin: 0 0 0 15px;padding-top: 10px">
    <el-col :span="12">
      <div class="item-box">
        <div class="icon-left"><img src="../../../assets/SHscreen/monitor_kefu.png"></div>
        <div class="info-right">
          <div><span>客服</span><br><span style="font-size: 12px;color: #cccccc">在线 / 总数</span></div>
          <div><span style="font-size: 20px;color: #24ff9b">{{ customeronlinecount }}</span> / <span style="font-size: 20px;color: #24bfff">{{customerservicecount}}</span></div>
        </div>
      </div>
    </el-col>
    <el-col :span="12">
      <div class="item-box">
        <div class="icon-left"><img src="../../../assets/SHscreen/monitor_waiqin.png"></div>
        <div class="info-right">
          <div><span>外勤</span><br><span style="font-size: 12px;color: #cccccc">总数</span></div>
          <div><span style="font-size: 20px;color: #24bfff">{{outsidecount}}</span></div>
        </div>
      </div>
    </el-col>
  </el-row>
<!--  客服在线人数： 律师在线人数：<br>-->
<!--  客服人数：{{customerservicecount}}  律师人数：{{lawercount}}<br>-->
<!--  服务商数量：{{suppliercount}}  外勤人员数量：<br>-->
<!--  服务商在线数：-->
</div>
</template>

<script>
export default {
  name: 'leftTopList',
  data () {
    return {
      isWeiNing: true,
      CustomerOnlineType: [
        {id: 1, customersipnum: '8001', isStatus: 0}, // 0 离线 1 在线 2 处理中
        {id: 2, customersipnum: '8002', isStatus: 0},
        {id: 3, customersipnum: '8003', isStatus: 0},
        {id: 4, customersipnum: '8004', isStatus: 0},
        {id: 5, customersipnum: '8005', isStatus: 0},
        {id: 6, customersipnum: '8006', isStatus: 0},
        {id: 7, customersipnum: '8007', isStatus: 0},
        {id: 8, customersipnum: '8008', isStatus: 0},
        {id: 9, customersipnum: '8009', isStatus: 0},
        {id: 10, customersipnum: '8010', isStatus: 0}
      ],
      suppliercount: 0,
      supplieronlinecount: 0,
      customerservicecount: 0,
      customeronlinecount: 0,
      lawercount: 0,
      laweronlinecount: 0,
      outsidecount: 0
    }
  },
  created () {
    // 登录返回 mqtt 中，包含 “/1/14/1323” 这个topic ，判断为老干局，需要显示老干局的监控页面
    let aa = '/1/14/1323'
    this.isWeiNing = this.$store.state.user.mqtts.indexOf(aa) === -1
    if (this.isWeiNing) {
      this.golobleObject.getHandleInfo = this.changeShowList
      this.golobleObject.getChangeKefu = this.getChangeKefu
    }
  },
  mounted () {
  },
  methods: {
    getDataList (obj) {
      this.suppliercount = obj.suppliercount
      this.supplieronlinecount = obj.supplieronlinecount
      this.customerservicecount = obj.customerservicecount
      this.customeronlinecount = obj.customeronlinecount
      this.lawercount = obj.lawercount
      this.laweronlinecount = obj.laweronlinecount
      this.outsidecount = obj.outsidecount
    },
    getCustomerOnlineType (arr) {
      if (arr !== null) {
        for (let i = 0; i < arr.length; i++) {
          for (let j = 0; j < this.CustomerOnlineType.length; j++) {
            if (arr[i].customersipnum === this.CustomerOnlineType[j].customersipnum) {
              this.CustomerOnlineType[j].isStatus = 1
            }
          }
        }
      }
      // this.CustomerOnlineType = arr !== null ? arr : []
    },
    changeShowList () {
      const handle = this.store2.state.other.isHandle
      console.log(888, handle)
      for (let i = 0; i < handle.length; i++) {
        for (let j = 0; j < this.CustomerOnlineType.length; j++) {
          if (handle[i].jobnum === this.CustomerOnlineType[j].customersipnum) {
            this.CustomerOnlineType[j].isStatus = 2
          }
        }
      }
    },
    getChangeKefu (obj) {
      console.log(888, obj)
      for (let i = 0; i < this.CustomerOnlineType.length; i++) {
        if (obj.jobnum === this.CustomerOnlineType[i].customersipnum) {
          this.CustomerOnlineType[i].isStatus = 1
        }
      }
    },
    test1 () {
      let dohandle = {id: 1, name: 'name', jobnum: '8001'}
      let vm = this
      this.store2.dispatch('other/update_is_handle', dohandle).then(() => {
        vm.changeShowList()
      })
    },
    test2 () {
      let dohandle = {id: 1, name: 'name', jobnum: '8001'}
      let vm = this
      this.store2.dispatch('other/update_del_handle', dohandle.id).then(() => {
        vm.getChangeKefu(dohandle)
      })
    }
  }
}
</script>

<style scoped>
.kefu-item{
  float: left;
  width: 20%;
  height: 25px;
}
.kefu-red{
  margin: 0 20px;
  height: 16px;
  line-height: 16px;
  background-color: #933535;
  font-size: 12px;
  color: white;
  text-align: center;
}
.kefu-green{
  margin: 0 20px;
  height: 16px;
  line-height: 16px;
  background-color: #1d8757;
  font-size: 12px;
  color: white;
  text-align: center;
}
.kefu-gray{
  margin: 0 20px;
  height: 16px;
  line-height: 16px;
  background-color: #999999;
  font-size: 12px;
  color: white;
  text-align: center;
}
.icon-left{
  height: 60px;
  width: 50px;
  float: left;
}
.icon-left img{
  width: 46px;
  height: 49px;
}
.info-right{
  font-size: 14px;
  height: 60px;
  float: left;
  width: calc(100% - 50px);
}
.item-box{
  height: 60px;
  font-size: 12px;
}
.item-box img{
  width: 40px;
  height: 40px;
}
.title-top{
  height: 30px;
  line-height: 40px;
}
.mun-bottom{
  height: 30px;
  line-height: 30px;
}
</style>



// WEBPACK FOOTER //
// src/components/monitoring/weiNingComponents/leftTopList.vue